export interface PaymentSettingDto {
  Id: string;
  ClientId?: string | null;
  WebPaymentTypeId: number;
  StripeKey?: string;
}

// WebPaymentType enum (backend Komut.Rentificial.Domain.WebSiteSettings.WebPaymentType)
export enum WebPaymentTypeEnum {
  None = 1,
  Stripe = 2,
  Iyzico = 3,
}
